export default __webpack_public_path__ + "static/media/CNo.90-7.54792600.jpg";